import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  Renderer2,
} from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiservicesService, } from 'src/app/services/apiservices.service';
import { environment } from 'src/environments/environment';
import {
  DomSanitizer,
  SafeHtml,
  SafeResourceUrl,
  SafeUrl,
} from '@angular/platform-browser';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { loadStripe, Stripe, StripeElements } from '@stripe/stripe-js';
import { DialogData } from 'listing-angular15';
// import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { delay, forkJoin, switchMap, take, takeWhile, tap, timer } from 'rxjs'; 
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { RitualChooseModalComponent } from '../ritual-choose-modal/ritual-choose-modal.component';

export interface Member {
  firstname: string;
  lastname: string;
  relation_type: string;
  [key: string]: any;
   name: string; 
  email: string; 
  relationship_status: string;
  profile_data: any; 
  sub_relation: string;
  _id: string;
  profile_status: string; 
}

export interface OtherData {
  other_fields: number;
  total_expected_fields: number;
  other_percentage: number;
}



export interface NatalChart {
  status: boolean;
  chart_url: string;
  msg: string;
}

export interface ApiData {
  natal_chart: NatalChart;
  summary: string;
}

export interface ApiResponse {
  status: string;
  message: string;
  data: ApiData;
}

export interface ChartData {
  createdDate: string;
  imageUrl: string;
  interpretation: string;
}

export interface MonthlyData {
  createdDate: string;
  imageUrl: string;
  interpretation: string;
}
@Component({
  selector: 'app-perennial-mandalism-dashboard',
  templateUrl: './perennial-mandalism-dashboard.component.html',
  styleUrls: ['./perennial-mandalism-dashboard.component.scss'],
})
export class PerennialMandalismDashboardComponent {

    showDelay = new FormControl(0);
  hideDelay = new FormControl(0);
  public memberShipData: any = {};
  public blogData: any = {};
  public mainBlog: any = {};
  public videoData: any = {};
  public mainVideo: any = {};
  public progressLoader: boolean = false;
  public cookieData: any = {};
  public api_url_for_managebanner = environment.api_url;
  public jwttokenformanagebanner = '';
  public contentArray: any = [];
  public contentCount: any;
  public loader: boolean = false;
  public subscribeLoader: boolean = false;
  startDate: Date | null = null;
  endDate: Date | null = null;
  currentFileName: string = '';
  membersData: Member[] = [];
  isLoading: boolean = true;      
  chartData: ChartData | null = null; 
  error: string | null = null;
  firstname: string;
  lastname: string;
  relation_type: string;
  [key: string]: any;
  selectedUserProfile: any | null = null
  otherData: OtherData | null = null; 
  monthlyData: MonthlyData | null = null;  


  
  constructor(
    private sanitizer: DomSanitizer,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private _bottomSheet: MatBottomSheet,
    public cookieService: CookieService,
    private apiservice: ApiservicesService,
    private renderer: Renderer2,
    public matSnackBar: MatSnackBar,
    public dialog: MatDialog,
    private http: HttpClient
  ) {
    this.cookieData = JSON.parse(
      this.cookieService.getAll()['login_user_details']
    );
  }

//   const cognitoId = this.cookieData?.userinfo?.cognito_user_id || "";
//   console.log("cognitoId====>",cognitoId)

//   this.loader = true;
//   this.apiservice
//     .getHttpDataPost('user/perennial_mandalism_aditonal_member-details-fetch', {
//       user_cognito_id: cognitoId
//     })
//     .subscribe({
//       next: (response: any) => {
//         console.log("API Response123:=========>", response);
//         if (response.status === 'success') {
//           this.membersData = response.result;
//           console.log("membersData====>",this.membersData)
//           if (this.membersData.length > 0) {
//             // console.log("profile_data====>", this.membersData[0].profile_data);
//           }
//         } else {
//           this.membersData = [];
//         }
//         this.loader = false;
//       },
//       error: (error) => {
//         console.error('API Error:', error);
//         this.loader = false;
//       }
//     });
// }




// Add this helper function to your component class if you don't have it already.
// Removed duplicate getInitials function.




  
fetchAdditionalMembers(): void {
  const cognitoId = this.cookieData?.userinfo?.cognito_user_id || "";
  console.log("cognitoId====>", cognitoId);

  this.loader = true;
  this.apiservice
    .getHttpDataPost('user/perennial_mandalism_aditonal_member-details-fetch', {
      user_cognito_id: cognitoId
    })
    .subscribe({
      next: (response: any) => {
        console.log("API Response:=========>", response);

       
        if (response?.status === 'success' && response?.result) {
          

          this.membersData = response.result.result || [];
          
         
          this.otherData = response.result.is_others;

          console.log("membersData correctly assigned:==========>", this.membersData);
          console.log("otherData correctly assigned:==========>", this.otherData);

        } else {
          console.error("API response is not in the expected format or has no data.");
          this.membersData = [];
          this.otherData = null; // <-- Also clear the new data on failure
        }
        this.loader = false;
      },
      error: (error) => {
        console.error('API Error:', error);
        this.membersData = [];
        this.otherData = null; // <-- Also clear the new data on error
        this.loader = false;
      }
    });
}


  getInitials(firstname: string, lastname: string): string {
    const firstInitial = firstname ? firstname.charAt(0) : '';
    const lastInitial = lastname ? lastname.charAt(0) : '';
    return (firstInitial + lastInitial).toUpperCase();
  }
  



  
  ngOnInit() {
    this.activatedRoute.data.subscribe((response: any) => {
      console.log('activatedRoute', response);
      if (response.response.status === 'success') {
        this.memberShipData = response?.response?.result;
        console.log("=================>",this.memberShipData);
      }
    });

    // this.membershipData();
    // this.membershipData();
    this.getContentCount();
    this.getDashboardContent();
 

     this.fetchAdditionalMembers()
      this.loadChart();
      this.monthlyChart();
    // this.getBlogData();
    // this.getVideoData();
    
  }

  //  showRitualPraxisModal(){}


    clickToEditProfile(userId: string): void {
    if (userId) {
      console.log("profile_id_to_fetch====>", userId);

     
      this.apiservice.getHttpDataPost('user/fetch-user-by-id', { _id: userId }).subscribe( 
        (userData: any) => {
          this.selectedUserProfile = userData.result; 
          console.log('Fetched User Profile1111======>:', this.selectedUserProfile);
       
          this.router.navigate([`perennial-mandalism-dashboard/add-member/${userId}`]);
        },
        (error: any) => {
          console.error('Error fetching user profile:', error);
         
        }
      );
    } else {
      console.warn("No user ID provided to clickToEditProfile.");
    }
  }

  onChartImgClick(imgUrl: string):void {
    const dialogRef = this.dialog.open(ChartImageModal, {
                  panelClass: ['custom-modalbox', 'chartimage-modalbox'],
                  data: {
                    url: imgUrl,
                  },
                });
    dialogRef.afterClosed().subscribe((result: any) => {
    });
  }

  onRitualCreate():void {
    const dialogRef = this.dialog.open(RitualChooseModalComponent, {
                  panelClass: ['custom-modalbox', 'ritual-praxis-modalbox'],
                  data: {
                    cookie: this.cookieData
                  }
                });
    dialogRef.afterClosed().subscribe((result: any) => {
    });
  }

  // loadChart(): void {
  //   // Reset state before fetching
  //   this.isLoading = true;
  //   this.error = null;

  //   this.apiservice.getNatalChartData().subscribe({
  //     next: (data) => {
  //       // This block runs on success
  //       this.chartData = data;
  //       console.log('Data received:', data);
  //     },
  //     error: (err) => {
  //       // This block runs on error
  //       this.error = err.message;
  //       console.error('An error occurred:', err);
  //       this.isLoading = false; // Stop loading on error
  //     },
  //     complete: () => {
  //       // This block runs when the observable completes (after success)
  //       this.isLoading = false; // Stop loading on success
  //     }
  //   });
  // }





//  loadChart(): void {
 
//   this.isLoading = true;
//   this.error = null;
//   this.chartData = null;
//   this.membersData = [];
//   this.otherData = null;


//   const userId = this.cookieData?.userinfo?._id || "";
//   console.log("userId====>", userId);
 

 
//   const astroDetails$ = this.apiservice.getHttpDataPost(
//     '/user/customer-astro-response-details-fetch',
//     {
//       astro_toolkit_tab: "western_horoscope_v2",
//       userid: userId
//     }
//   );
// console.log("astroDetails====>",astroDetails$)



//   forkJoin([astroDetails$]).subscribe({
//     next: ([astroResponse]: [any]) => {
//       console.log("All responses received!======>",astroResponse);

     
//       if (astroResponse && astroResponse.status === 'success' && astroResponse.data) {
//         console.log("Astro API Response:=========>963", astroResponse);
//         this.chartData = {
//           createdDate: new Date().toLocaleDateString('en-GB', {
//             day: '2-digit', month: 'long', year: 'numeric'
//           }),
//           imageUrl: astroResponse.data.natal_chart.chart_url,
//           interpretation: astroResponse.data.summary
//         };
//         console.log("ChartData correctly assigned:258=========>", this.chartData);
//       } else {
//         console.error("Astro API response is not in the expected format.");
//       }

    

//       this.isLoading = false;
//     },
//     error: (err) => {
    
//       console.error('An error occurred in one of the API calls:', err);
//       this.error = 'Failed to load all required data. Please try again.';
//       this.isLoading = false;
//     }
//   });
// }



// loadChart(): void {
//   this.isLoading = true;
//   this.error = null;
//   this.chartData = null;

//   const userId = this.cookieData?.userinfo?._id || "";

//   const astroDetails$ = this.apiservice.getHttpDataPost(
//     '/user/customer-astro-response-details-fetch',
//     {
//       astro_toolkit_tab: "western_horoscope_v2",
//       userid: userId
//     }
//   );

//   forkJoin([astroDetails$]).pipe(
//     delay(10000) 
//   ).subscribe({
//     next: ([astroResponse]: [any]) => {
//       console.log("All responses received!======>", astroResponse);

//       if (astroResponse && astroResponse.status === 'success' && astroResponse.data) {
//         this.chartData = {
//           createdDate: new Date().toLocaleDateString('en-GB', {
//             day: '2-digit', month: 'long', year: 'numeric'
//           }),
//           imageUrl: astroResponse.data.natal_chart.chart_url,
//           interpretation: astroResponse.data.summary
//         };
//       } else {
//         console.error("Astro API response is not in the expected format.");
//       }

//       this.isLoading = false; // This now runs after the 2-second delay
//     },
//     error: (err) => {
//       console.error('An error occurred:', err);
//       this.error = 'Failed to load chart data. Please try again.';
//       this.isLoading = false; // This also runs after the 2-second delay
//     }
//   });
// }




loadChart(): void {
  this.isLoading = true;
  this.error = null;
  this.chartData = null;

  const userId = this.cookieData?.userinfo?._id || "";

  timer(0, 10000).pipe( // CHANGED: 10s interval
    switchMap(() => this.apiservice.getHttpDataPost(
      '/user/customer-astro-response-details-fetch',
      {
        astro_toolkit_tab: "western_horoscope_v2",
        userid: userId
      }
    )),
    tap((response: any) => {
      console.log('Polling (natal): data present?', !!response?.data);
    }),
    // CHANGED: keep polling while data is null/undefined
    takeWhile((response: any) => !response?.data, true)
  ).subscribe({
    next: (finalResponse: any) => {
      if (finalResponse?.data) {
        this.chartData = {
          createdDate: new Date().toLocaleDateString('en-GB', {
            day: '2-digit', month: 'long', year: 'numeric'
          }),
          imageUrl: finalResponse.data.natal_chart?.chart_url,
          interpretation: finalResponse.data.summary
        };
      } else {
        // timeout (no data after max retries)
        this.error = 'Could not generate the chart in time. Please try again.';
      }
      this.isLoading = false;
    },
    error: () => {
      this.error = 'A server error occurred. Please try again.';
      this.isLoading = false;
    }
  });
}


// monthlyChart():void{

//    this.isLoading = true;
//   this.error = null;
//   this.chartData = null;
//   this.membersData = [];
//   this.otherData = null;
//   this.monthlyData = null; 


//   const userId = this.cookieData?.userinfo?._id || "";
//   console.log("userId====>", userId);
 

 
//   const astroDetails$ = this.apiservice.getHttpDataPost(
//     '/user/customer-astro-response-details-fetch',
//     {
//       astro_toolkit_tab: "tropical_transits_monthly_v3",
//       userid: userId
//     }
//   );
// console.log("astroDetails====>",astroDetails$)



//   forkJoin([astroDetails$]).pipe(
//     delay(10000) 
//   ).subscribe({
//     next: ([astroResponse]: [any]) => {
//       console.log("tropical_transits_monthly_v3!======>",astroResponse);

     
//       if (astroResponse && astroResponse.status === 'success' && astroResponse.data) {
//         console.log("Astro API Response tropical_transits_monthly_v3:=========>963", astroResponse);
//         this['monthlyData'] = {
//           createdDate: new Date().toLocaleDateString('en-GB', {
//             day: '2-digit', month: 'long', year: 'numeric'
//           }),
//           imageUrl: astroResponse.data.natal_chart.chart_url,
//           interpretation: astroResponse.data.summary
//         };
//         console.log("ChartData correctly assigned:258 tropical_transits_monthly_v3=========>", this['monthlyData']);
//       } else {
//         console.error("Astro API response is not in the expected format.");
//       }

    

//       this.isLoading = false;
//     },
//     error: (err) => {
    
//       console.error('An error occurred in one of the API calls:', err);
//       this.error = 'Failed to load all required data. Please try again.';
//       this.isLoading = false;
//     }
//   });

// }

monthlyChart(): void {
  // --- Spinner starts here ---
  this.isLoading = true;
  this.error = null;
  this.chartData = null;
  this.membersData = [];
  this.otherData = null;
  this.monthlyData = null;

  const userId = this.cookieData?.userinfo?._id || "";

  // 2. Start polling immediately, then every 10 seconds
  timer(0, 10000).pipe( // keep 10s interval
    switchMap(() => this.apiservice.getHttpDataPost(
      '/user/customer-astro-response-details-fetch',
      {
        astro_toolkit_tab: "tropical_transits_monthly_v3",
        userid: userId
      }
    )),
    tap((response: any) => {
      console.log('Polling (monthly): data present?', !!response?.data);
    }),
    // CHANGED: stop only when data exists
    takeWhile((response: any) => !response?.data, true)
  ).subscribe({
    next: (finalResponse: any) => {
      if (finalResponse?.data) {
        this.monthlyData = {
          createdDate: new Date().toLocaleDateString('en-GB', {
            day: '2-digit', month: 'long', year: 'numeric'
          }),
          imageUrl: finalResponse.data.natal_chart?.chart_url,
          interpretation: finalResponse.data.summary
        };
      } else {
        this.error = 'Could not generate the monthly chart in time. Please try again.';
      }
      this.isLoading = false;
    },
    error: () => {
      this.error = 'A server error occurred. Please try again later.';
      this.isLoading = false;
    }
  });
}



  membershipData() {
     const cognitoId = this.cookieData?.userinfo?.cognito_user_id || "";
  console.log("cognitoId====>",cognitoId)
    this.apiservice
      .getHttpDataPost('user/fetch-membership-details', {
        user_cognito_id: cognitoId,
      })
      .subscribe((response: any) => {
        this.memberShipData = response.result;
      });
  }

  getBlogData() {
    this.apiservice
      .getHttpDataPost('blogmanagement/list-for-front-end', {
        condition: { limit: 10, skip: 0 },
        searchcondition: {},
        sort: { type: 'desc', field: 'created_on' },
        project: {},
        token: '',
      })
      .subscribe((response: any) => {
        this.blogData = response.results.list;
        this.mainBlog = response.results.list[0];
      });
  }

  getVideoData() {
    this.apiservice
      .getHttpDataPost('videomanagement/list-for-front-end', {
        condition: { limit: 10, skip: 0 },
        searchcondition: {},
        sort: { type: 'desc', field: 'created_on' },
        project: {},
        token: '',
      })
      .subscribe((response: any) => {
        this.videoData = response.results.list;
        this.mainVideo = response.results.list[0];
      });
  }

  htmlSanitaizer(val: any) {
    let value = this.sanitizer.bypassSecurityTrustHtml(val);
    return value;
  }

  videoPlayer(obj: any): any {
    let videoValue = obj[0]; // assuming you want to show the first video
    if (videoValue.videotype == 1) {
      return this.htmlSanitaizer(
        `<iframe width="560" height="315" src="https://www.youtube.com/embed/${videoValue.youtube_link}" title="${videoValue.youtube_title}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`
      );
    } else if (videoValue.videotype == 3) {
      const videoFile = videoValue.videofile[0];
      return this.htmlSanitaizer(
        `<video width="560" height="315" controls>
          <source src=" https://awsbackend-dev-patient-files-test.s3.amazonaws.com/${videoFile.baseurl}${videoFile.fileservername}" type="${videoFile.type}">
          Your browser does not support the video tag.
        </video>`
      );
    }
    // https://awsbackend-dev-patient-files-test.s3.amazonaws.com/practicepresence-cancer-backend-angular/blogvideo/blogvideo-17280414639321851190-uhd_3840_2160_25fps.mp4
    return null; // if no valid video type is found
  }

  getDashboardContent() {
    this.loader = true;
    let reqBody = {
      searchcondition: {},
      sort: { type: 'asc', field: 'priority' },
      project: {},
      token: '',
    };
    this.apiservice
      .getHttpDataPost('content/content-list-for-frontend', reqBody)
      .subscribe({
        next: (response) => {
          console.log(response, 'response');
          if (response.status == 'success') {
            this.contentArray = response?.results?.res
              ? response.results.res
              : [];
            this.loader = false;
            console.log(this.contentArray, 'tabledata');
          }
        },
        error: (error) => {
          this.loader = false;
        },
      });
  }

  getContentCount() {
    this.apiservice.getHttpData('content/content-type-counts').subscribe({
      next: (response) => {
        console.log(response);
        this.contentCount = response.counts;
        console.log(response);
      },
      error: (error) => {},
    });
  }

  getThumbnail(item: any): string {
    return (
      item.thumbnail_path?.baseurl + item.thumbnail_path?.fileservername ||
      'default-thumbnail.png'
    );
  }

  getDocumentUrl(item: any): string {
    return item.file_path?.baseurl + item.file_path?.fileservername;
  }

  // playVideo(item: any) {
  //   if (item.file_path) {
  //     window.open(
  //       item.file_path.baseurl + item.file_path.fileservername,
  //       '_blank'
  //     );
  //   }
  // }

  getSanitizedYouTubeUrl(url: string, isPlaying: boolean): SafeResourceUrl {
    if (!url) return '';

    const embedUrl = `https://www.youtube.com/embed/${url}`;
    const autoplayUrl = isPlaying ? `${embedUrl}?autoplay=1&mute=1` : embedUrl;

    return this.sanitizer.bypassSecurityTrustResourceUrl(autoplayUrl);
  }

  sanitizeUrlRaw(url: string): SafeUrl {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url; // Ensure proper URL format
    }
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  getSanitizedYouTubeUrlFullUrl(
    url: string,
    isPlaying: boolean
  ): SafeResourceUrl {
    console.log(url, isPlaying, 'testsanket');
    if (!url) return '';
    const videoId = this.extractYouTubeVideoId(url);
    const embedUrl = `https://www.youtube.com/embed/${videoId}`;
    const autoplayUrl = isPlaying ? `${embedUrl}?autoplay=1&mute=1` : embedUrl;
    return this.sanitizer.bypassSecurityTrustResourceUrl(autoplayUrl);
  }

  getSanitizedYouTubeFullUrlEmbed(
    url: string,
    isPlaying: boolean
  ): SafeResourceUrl {
    console.log(url, isPlaying);
    if (!url) return '';
    const autoplayUrl = isPlaying ? `${url}&autoplay=1&mute=1` : url;
    return this.sanitizer.bypassSecurityTrustResourceUrl(autoplayUrl);
  }

  extractYouTubeVideoId(url: string): string {
    const videoIdMatch = url.match(
      /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([^&]+)/
    );
    return videoIdMatch ? videoIdMatch[1] : '';
  }

  isYouTubeUrl(url: string): boolean {
    return (
      !!url && typeof url === 'string' && url.toLowerCase().includes('youtube')
    );
  }

  shouldShowVideo(item: any): boolean {
    return (
      ((item.direct_url && !this.isYouTubeUrl(item.direct_url)) ||
        (item.embed_url && !this.isYouTubeUrl(item.embed_url))) &&
      item.isPlaying
    );
  }

  shouldShowIframe(item: any): boolean {
    return (
      ((item.direct_url && this.isYouTubeUrl(item.direct_url)) ||
        (item.embed_url && this.isYouTubeUrl(item.embed_url))) &&
      item.isPlaying
    );
  }

  playVideo(item: any) {
    this.contentArray.forEach((i: any) => {
      if (i !== item) {
        i.isPlaying = false;
      }
    });

    item.isPlaying = !item.isPlaying;
  }

  redirecttoAditionalpage() {
    // if (this.memberShipData.memberCount > 0) {
      this.router.navigateByUrl(
        `/perennial-mandalism-dashboard/additional_member`
      );
    // } else {
    //   this.matSnackBar.open('No additional member has been added yet.', '', {
    //     duration: 3000,
    //   });
    // }
  }

  // << ------------- Search Functions ------------- >>

  refreshFields(): void {
    this.startDate = null;
    this.endDate = null;
    this.getDashboardContent();
    this.matSnackBar.open('New Range of Data Loaded !!', '', {
      duration: 10000,
    });
  }

  search(): void {
    this.loader = true;
    let payload = {
      searchcondition: {
        display_dates: {} as
          | Partial<{ $gte: number; $lte: number }>
          | undefined,
      },
      sort: { type: 'asc', field: 'priority' },
      project: {},
      token: '',
    };

    if (this.startDate) {
      payload.searchcondition.display_dates =
        payload.searchcondition.display_dates || {};
      payload.searchcondition.display_dates.$gte = Math.floor(
        this.startDate.getTime()
      );
    }

    if (this.endDate) {
      payload.searchcondition.display_dates =
        payload.searchcondition.display_dates || {};
      payload.searchcondition.display_dates.$lte = Math.floor(
        this.endDate.getTime()
      );
    }

    if (
      payload.searchcondition.display_dates &&
      Object.keys(payload.searchcondition.display_dates).length === 0
    ) {
      payload.searchcondition.display_dates = undefined;
    }

    this.apiservice
      .getHttpDataPost('content/content-list-for-frontend', payload)
      .subscribe({
        next: (response) => {
          console.log(response);
          if (response.status == 'success' && response.results.res.length > 0) {
            this.contentArray = [];
            this.contentArray = response.results.res;
            this.matSnackBar.open('New Range of Data Loaded !!', '', {
              duration: 10000,
            });
          } else {
            this.matSnackBar.open('No Data Found in this Range !!', '', {
              duration: 10000,
            });
          }

          this.loader = false;
        },
        error: (error) => {
          this.matSnackBar.open('Something Went Wrong !!', '', {
            duration: 10000,
          });
          this.loader = false;
        },
      });
  }

  registerClick() {
    this.router.navigateByUrl(
      `/mysteryschool-signup/${this.cookieData.userinfo._id}`
    );
  }

  // << ------------------- File Download Directly ----------- >>

  async downloadFile(item: any) {
    const fileUrl = `https://d37pbainmkhx6o.cloudfront.net/${item.file_path.baseurl}${item.file_path.fileservername}`;
    this.currentFileName = item.file_path.name;

    try {
      const response = await fetch(fileUrl);
      if (!response.ok) {
        throw new Error('Failed to download file');
      }

      const blob = await response.blob();

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = this.currentFileName;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);

      this.matSnackBar.open(`Downloading ${this.currentFileName}...`, 'Close', {
        duration: 5000,
      });
    } catch (error) {
      console.error('Error downloading file:', error);
      this.matSnackBar.open('Failed to download file', 'Close', {
        duration: 5000,
      });
    }
  }

  unsubscribeOpen() {
    if (!this.cookieData?.userinfo?.perennial_subscription_id) {
      this.matSnackBar.open(
        'Subscription information is missing. Cannot proceed.',
        '',
        { duration: 5000 }
      );
      return;
    }

    const dialogRef = this.dialog.open(PerennialSubscriptionModal, {
      panelClass: ['custom-modalbox', 'mystery-subscription-modalbox'],
      data: {
        subscription_id: this.cookieData.userinfo.perennial_subscription_id,
        expiry_date: this.cookieData.userinfo.perennial_current_period_end,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed with result:', result);
      if (result === true) {
        let oldcookie = JSON.parse(
          this.cookieService.get('login_user_details')
        );
        let newcookie = {
          lastLoginTime: oldcookie.lastLoginTime,
          token: oldcookie.token,
          token_expiry: oldcookie.token_expiry,
          userinfo: {
            ...oldcookie.userinfo,
            perennial_subscription_status: false,
          },
        };
        console.log('newcookie', newcookie);
        this.cookieService.set(
          'login_user_details',
          JSON.stringify(newcookie),
          { path: '/' }
        );
        this.cookieData = newcookie;
        this.matSnackBar.open(
          'Unsubscription initiated successfully. Access remains until expiry.',
          'Ok',
          { duration: 5000 }
        );
      }
    });
  }

  subscribeOpen() {
    this.subscribeLoader = true;
    const body = {
      customer_id: this.cookieData.userinfo._id,
      email: this.cookieData.userinfo.email,
    };

    this.apiservice
      .getHttpDataPost('cart_management/subscription-payment', body)
      .subscribe({
        next: (response: any) => {
          console.log('response', response);

          if (response.status === 'success' && response.results) {
            let dataObj = {
              clientSecret: response.clientSecret,
              customerId: response.customerId,
              subscriptionId: response.subscriptionId,
              setupIntentClientSecret:response.setupIntentClientSecret,
            };
            this.subscribeLoader = false;
            console.log('response.results perennial', dataObj);

            this.openStripeModal({ ...dataObj, ...body });
          } else {
            this.subscribeLoader = false;
            this.matSnackBar.open(
              response.message ||
                'Failed to initiate subscription. Please try again.',
              'Close',
              { duration: 5000 }
            );
          }
        },
        error: (error: any) => {
          this.subscribeLoader = false;
          const errorMessage =
            error?.error?.message ||
            'An error occurred while initiating subscription.';
          this.matSnackBar.open(errorMessage, 'Close', { duration: 5000 });
        },
      });
  }

  private openStripeModal(dataObj: any): void {
    console.log('dataObj perrenial', dataObj);

    const dialogRef = this.dialog.open(PerennialStripeModal, {
      panelClass: ['custom-modalbox', 'stripe-modalbox'],
      data: {
        dataObj: dataObj,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      console.log('AuthGuard: Stripe Modal closed with result:', result);
    });
  }





onViewFullChart(tab: string): void {

      const userID =this.cookieData.userinfo._id
    console.log("userType==>",userID)
   const queryParams = new URLSearchParams({
      tab: tab,
      show_horoscope: 'true',
      user_id: userID
    });

console.log("queryParams=====>",queryParams)
const newUrl = this.router.serializeUrl(
      this.router.createUrlTree(['/horoscope'], {
        queryParams: {
          tab: tab,
          showResultSection: true,
          customer: userID
        }
      })
    );

    // Open in a new tab
    window.open(newUrl, '_blank');
  }


   openCompatibilityTab(): void {
    // This creates the URL for your route
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/perennial-mandalism-dashboard/relationship-details'])
    );
    
    // This uses the browser to open that URL in a new tab
    window.open(url, '_blank');
  }

  goToAccountInfo(): void {

          const userID =this.cookieData.userinfo._id
    console.log("userType==>",userID)
    this.router.navigate([`my-account/account-info/${userID}`]);
  }

  // clickToEditProfile(): void {
  //    if (this.membersData.length > 0) {
  //           console.log("profile_data====>", this.membersData[0]._id);
            
  //         }
  // }


  navigateToAddMember(): void {
    this.router.navigate(['/perennial-mandalism-dashboard/add-member']);
  }



  //   getInitials(name: string): string {
  //   if (!name) return '';
  //   const words = name.trim().split(' ');
  //   if (words.length === 1) return words[0][0].toUpperCase();
  //   return (words[0][0] + words[1][0]).toUpperCase();
  // }





}












// << ------------------ Subscription Modal ------------------ >>

@Component({
  selector: 'PerennialSubscriptionModal',
  templateUrl: './perennial-subscription-modal.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, SharedModule],
})
export class PerennialSubscriptionModal {
  public prevData: any;

  constructor(
    public dialogRef: MatDialogRef<PerennialSubscriptionModal>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public matSnackBar: MatSnackBar,
    private apiService: ApiservicesService
  ) {
    this.prevData = data;
  }

  public isLoading: boolean = false;

  ngOnInit() {}

  public unsubscribe() {
    this.isLoading = true;
    const payload = {
      subscription_id: this.prevData.subscription_id,
    };
    const endpoint = 'stripe/unsubscribe-stripe-Perennial';

    this.apiService.getHttpDataPost(endpoint, payload).subscribe({
      next: (response: any) => {
        console.log('Unsubscribe response:', response);
        this.dialogRef.close(true);
        this.isLoading = false;
      },
      error: (error: any) => {
        const errorMessage = 'Failed to unsubscribe. Please try again.';
        this.matSnackBar.open(errorMessage, '', {
          duration: 5000,
        });
        this.isLoading = false;
        this.closeModal();
      },
    });
  }

  public closeModal() {
    this.dialogRef.close(false);
  }
}

// << ------------------ Stripe Perennial Comp ------------------ >>

@Component({
  selector: 'PerennialStripeModal',
  templateUrl: './perennialStripeModal.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, SharedModule, CommonModule],
})
export class PerennialStripeModal implements OnInit {
  stripe: Stripe | null = null;
  elements: StripeElements | null = null;
  clientSecret: string = '';
  public modalData: any = null;
  public stripeData: any = null;
  isLoading: boolean = false;
  public cookieData: any = {};
  setupIntentClientSecret: string = '';
  mode: 'payment' | 'setup' | 'noClientSecret' | undefined;

  constructor(
    public dialogRef: MatDialogRef<PerennialStripeModal>,
    private apiService: ApiservicesService,
    @Inject(MAT_DIALOG_DATA) public data: { index: any; item: any },
    public matSnackBar: MatSnackBar,
    public dialog: MatDialog,
    public cookieService: CookieService,
    private cdr: ChangeDetectorRef
  ) {
    this.modalData = data;
    this.cookieData = JSON.parse(
      this.cookieService.getAll()['login_user_details']
    );
  }

  public userformdata: any = null;
  async ngOnInit() {
    console.log('this.modalData.dataObj_new', this.modalData);
    if (!this.modalData || !this.modalData.dataObj) {
      console.error('Modal data or dataObj is missing!');
      this.mode = 'noClientSecret';
      return;
    }

    this.stripeData = this.modalData.dataObj;
    this.clientSecret = this.modalData.dataObj.clientSecret;
    this.setupIntentClientSecret =
      this.modalData.dataObj.setupIntentClientSecret;

    try {
      this.stripe = await loadStripe(environment.stripe_pub_key);
    } catch (error) {
      console.error('Error loading Stripe:', error);
      this.mode = 'noClientSecret'; // Or a specific error mode
      return;
    }

    if (!this.stripe) {
      console.error('Stripe.js failed to load.');
      this.mode = 'noClientSecret'; // Or a specific error mode
      return;
    }

    let clientSecretForElements: string | undefined;
    if (this.clientSecret) {
      console.log('Initializing for Payment Intent (clientSecret provided)');
      this.mode = 'payment';
      clientSecretForElements = this.clientSecret;
    } else if (this.setupIntentClientSecret) {
      console.log(
        'Initializing for Setup Intent (setupIntentClientSecret provided)'
      );
      this.mode = 'setup';
      clientSecretForElements = this.setupIntentClientSecret;
    } else {
      console.log('No clientSecret or setupIntentClientSecret found.');
      this.mode = 'noClientSecret';
    }
    this.cdr.detectChanges();

    if (
      (this.mode === 'payment' || this.mode === 'setup') &&
      clientSecretForElements
    ) {
      // It's often safer to wait for the next tick to ensure DOM is fully updated.
      // Using Promise.resolve().then() or setTimeout can help.
      Promise.resolve()
        .then(() => {
          if (this.stripe && clientSecretForElements) {
            // Re-check stripe due to closure
            console.log(
              `Attempting to mount Stripe Element for mode: ${this.mode}`
            );

            const paymentElementContainer = document.getElementById(
              'perennial-payment-element'
            );

            if (paymentElementContainer) {
              this.elements = this.stripe.elements({
                clientSecret: clientSecretForElements,
              });
              const paymentElement = this.elements.create('payment'); // 'payment' type element is used for both
              paymentElement.mount('#perennial-payment-element');
              console.log(
                `Successfully mounted Stripe Element for mode: ${this.mode}`
              );
            } else {
              console.error(
                `ERROR: #perennial-payment-element not found in DOM for mode: ${this.mode} even after mode assignment and tick.`
              );
            }
          }
        })
        .catch((error) => {
          console.error('Error in Promise for mounting Stripe element:', error);
        });
    } else if (this.mode !== 'noClientSecret') {
      console.error(
        `Stripe element will not be mounted. Mode: ${this.mode}, Client Secret for Elements: ${clientSecretForElements}`
      );
    }

    // if (this.stripe && this.clientSecret) {
    //   console.log('Stripe loaded and client secret is available', this.clientSecret, this.stripe);

    //   this.elements = this.stripe.elements({ clientSecret: this.clientSecret });
    //   const paymentElement = this.elements.create('payment');
    //   paymentElement.mount('#perennial-payment-element');
    // }
  }

  async handleSubmit(event: Event) {
    event.preventDefault();
    if (!this.stripe || !this.elements) return;

    this.isLoading = true;

    try {
      console.log('this.modalData.dataObj123', this.modalData.dataObj,this.modalData.dataObj.customer_id);
      console.log('this.cookieData', this.cookieData);

      let cookiebody = {
        customer_id: this.modalData.dataObj.customerId,
        subscription_id: this.modalData.dataObj.subscriptionId,
        user_id: this.modalData.dataObj.customer_id,
        email: this.modalData.dataObj.email,
        name: this.cookieData?.userinfo?.name,
      };

      this.cookieService.set(
        'perennialStripeUserDetails',
        JSON.stringify(cookiebody),
        { path: '/' }
      );

      
      const { error } = await this.stripe.confirmPayment({
        elements: this.elements,
        confirmParams: {
          return_url: `${window.location.origin}/perennial-stripe-success-page`,
        },
        redirect: 'always',
      });

      if (error) {
        this.matSnackBar.open(
          `Payment failed: ${error.message || 'Unknown error'}`,
          '',
          { duration: 5000 }
        );
        this.isLoading = false;
      }
    } catch (e) {
      this.matSnackBar.open(
        'An unexpected error occurred. Please try again.',
        '',
        { duration: 5000 }
      );
      this.isLoading = false;
    }
    // this.dialogRef.close('success');
  }

  async handleSetupSubmit(event: Event) {
    console.log('handleSetupSubmit called');

    event.preventDefault();
    if (!this.stripe || !this.elements) return;

    this.isLoading = true;


     console.log('this.modalData.dataObj123', this.modalData.dataObj,this.modalData.dataObj.customer_id);
      console.log('this.cookieData', this.cookieData);

    let cookiebody = {
      customer_id: this.modalData.dataObj.customerId,
      subscription_id: this.modalData.dataObj.subscriptionId,
      user_id: this.modalData.dataObj.customer_id,
      email: this.modalData.dataObj.email,
      name: this.cookieData?.userinfo?.name,
    };
      console.log('cookiebody', cookiebody);

    this.cookieService.set(
      'perennialStripeUserDetails',
      JSON.stringify(cookiebody),
      { path: '/' }
    );

    const result = await this.stripe.confirmSetup({
      elements: this.elements,
      confirmParams: {
        return_url: `${window.location.origin}/perennial-stripe-success-page`,
      },
      redirect: 'always',
    });
  }
}


//chart image showing modal

interface ChartImageData {
  url: string;
  alt?: string;
}

@Component({
  selector: 'chartImage-modal',
  templateUrl: 'chartImage-modal.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, SharedModule],
})
export class ChartImageModal {
  safeSrc: SafeUrl;

  constructor(
    public dialogRef: MatDialogRef<ChartImageModal>,
    @Inject(MAT_DIALOG_DATA) public data: ChartImageData,
    private apiservice: ApiservicesService, public matSnackBar: MatSnackBar,
    private sanitizer: DomSanitizer
  ) {
    this.safeSrc = this.sanitizer.bypassSecurityTrustUrl(data?.url ?? '');
    // console.log(this.modaldata.mailObj, "modal data++");
  }

  ngOnInit() {
    // console.log("modaldata mail data", this.modaldata);
  }

  public closeModal() {
    this.dialogRef.close();
  }

}

//invoking and banishing chosing modal

type ElementType = 'Fire' | 'Water' | 'Air' | 'Earth' | 'Spirit';

interface AstroItem {
  name: string;
  element: ElementType;
  svg: string; // inline SVG markup as string
}

interface RitualVideo {
  video_title: string;
  video_url: string;
  video_description: string;
  video_thumbnail: string;
  tag: string[];
  priority: number;
  status: number;
}

interface RitualChooseDialogData {
  cookie?: any;
}

@Component({
  selector: 'dynamic-ritual-choose-modal',
  templateUrl: 'dynamic-ritual-choose-modal.html',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatChipsModule,
    MatIconModule,
    MatRadioModule,
    MatSnackBarModule,
    SharedModule,
  ],
})
export class DynamicRitualPraxisChooseModal {
  public cookieData: any;
  public isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DynamicRitualPraxisChooseModal>,
    private sanitizer: DomSanitizer,
    private snack: MatSnackBar,
    private apiService: ApiservicesService,
    public router: Router,
    @Inject(MAT_DIALOG_DATA) public data: RitualChooseDialogData,
  ) {
    this.cookieData = this.data;
  }

  safeSvg(svg: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }

  public closeModal() {
    this.dialogRef.close();
  }

  // ---- Data ----
  planets: AstroItem[] = [
    { name: 'Jupiter', element: 'Fire', svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12h12"/><path d="M14 2a10 10 0 0 0-10 10v0"/><path d="M14 22a10 10 0 0 1-10-10v0"/></svg>` },
    { name: 'Mars', element: 'Fire', svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="m19 5-14 14"/></svg>` },
    { name: 'Mercury', element: 'Air', svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="6" r="4"/><path d="M12 10v12"/><path d="M8 18h8"/><path d="M8 14h8"/></svg>` },
    { name: 'Moon', element: 'Water', svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"/></svg>` },
    { name: 'Neptune', element: 'Water', svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12h20"/><path d="M12 2a10 10 0 0 0-5.5 18"/><path d="M12 22a10 10 0 0 0 5.5-18"/></svg>` },
    { name: 'Pluto', element: 'Spirit', svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2a10 10 0 0 0-5.5 18"/><path d="M12 2v20"/><circle cx="12" cy="8" r="3"/></svg>` },
    { name: 'Saturn', element: 'Earth', svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12h12"/><path d="M14 2a10 10 0 0 0-10 10v0"/><path d="M12 12h2"/></svg>` },
    { name: 'Sun', element: 'Spirit', svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="m4.93 4.93 1.41 1.41"/><path d="m17.66 17.66 1.41 1.41"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="m4.93 19.07 1.41-1.41"/><path d="m17.66 6.34 1.41-1.41"/></svg>` },
    { name: 'Uranus', element: 'Air', svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v10"/><path d="M12 12h10"/><path d="M12 12H2"/><path d="M12 12a5 5 0 0 0 5 5v0a5 5 0 0 0-10 0v0a5 5 0 0 0 5-5Z"/></svg>` },
    { name: 'Venus', element: 'Earth', svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="6"/><path d="M12 14v8"/><path d="M8 20h8"/></svg>` },
  ];

  zodiacs: AstroItem[] = [
    { name: 'Aquarius', element: 'Air', svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m3 15 4-4 4 4 4-4 4 4"/><path d="m3 8 4-4 4 4 4-4 4 4"/></svg>` },
    { name: 'Aries', element: 'Fire', svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14"/><path d="M17 5s-5 3-5 7 5 7 5 7"/></svg>` },
    { name: 'Cancer', element: 'Water', svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9a6 6 0 0 1 6-6v0a6 6 0 0 1 6 6"/><path d="M18 15a6 6 0 0 1-6 6v0a6 6 0 0 1-6-6"/></svg>` },
    { name: 'Capricorn', element: 'Earth', svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 3v4"/><path d="M16 7a2 2 0 0 1-2 2H6"/><path d="M14 9s-1 1-4 1-4-1-4-1"/><path d="M10 17a4 4 0 1 0-8 0c0-2 2-3 4-3s4 1 4 3Z"/></svg>` },
    { name: 'Gemini', element: 'Air', svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M3 18h18"/><path d="M7 6v12"/><path d="M17 6v12"/></svg>` },
    { name: 'Leo', element: 'Fire', svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 4a8 8 0 0 1 8 8 8 8 0 0 1-8 8"/><path d="M20 12c0-2.5-2-4-4-4"/><path d="M16 12a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z"/></svg>` },
    { name: 'Libra', element: 'Air', svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12h16"/><path d="M4 16h16"/><path d="M8 12V8c0-2.2 1.8-4 4-4s4 1.8 4 4v4"/></svg>` },
    { name: 'Pisces', element: 'Water', svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 21a6 6 0 0 1 0-12 6 6 0 0 0 0-6"/><path d="M19 3a6 6 0 0 1 0 12 6 6 0 0 0 0 6"/><path d="M5 12h14"/></svg>` },
    { name: 'Sagittarius', element: 'Fire', svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m21 21-6-6"/><path d="m3 3 6 6"/><path d="M15 3h6v6"/><path d="M9 21H3v-6"/></svg>` },
    { name: 'Scorpio', element: 'Water', svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 10h5"/><path d="M9 10s1 0 1-1V5"/><path d="M12 4h1a2 2 0 0 1 2 2v1"/><path d="m14 10 3 3 3-3"/><path d="M17 10v10"/></svg>` },
    { name: 'Taurus', element: 'Earth', svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3a6 6 0 0 0 12 0"/><path d="M12 21a6 6 0 0 0 0-12 6 6 0 0 0 0 12Z"/></svg>` },
    { name: 'Virgo', element: 'Earth', svg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4v16"/><path d="M8 4v16"/><path d="M12 4v16"/><path d="M16 4v16"/><path d="M20 4v16"/></svg>` },
  ];

  // ---- Form Controls ----
  selectedPlanets = new FormControl<AstroItem[]>([]);
  selectedZodiacs = new FormControl<AstroItem[]>([]);
  selectedAction  = new FormControl<'invocation' | 'banishing'>('invocation');

  // ---- Display Lists (for chips) ----
  selectedPlanetsList: AstroItem[] = [];
  selectedZodiacsList: AstroItem[] = [];

  get isBanishing(): boolean {
    return this.selectedAction.value === 'banishing';
  }

  ngOnInit() {
    this.selectedPlanets.valueChanges.subscribe(v => this.selectedPlanetsList = v || []);
    this.selectedZodiacs.valueChanges.subscribe(v => this.selectedZodiacsList = v || []);

    const applyMode = (mode: 'invocation' | 'banishing') => {
      if (mode === 'banishing') {
        this.selectedZodiacs.setValue([]);
        this.selectedZodiacs.disable({ emitEvent: false });
      } else {
        this.selectedZodiacs.enable({ emitEvent: false });
      }
    };
    
    applyMode(this.selectedAction.value ?? 'invocation');
    this.selectedAction.valueChanges.subscribe(m => applyMode(m ?? 'invocation'));
  }

  // ---- Helpers ----
  getElementColorHex(element: string): string {
    switch ((element || '').toLowerCase()) {
      case 'fire':   return '#DC2626';
      case 'water':  return '#2563EB';
      case 'air':    return '#F59E0B';
      case 'earth':  return '#16A34A';
      case 'spirit': return '#7C3AED';
      default:       return '#6B7280';
    }
  }

  removePlanet(planet: AstroItem): void {
    const curr = this.selectedPlanets.value || [];
    this.selectedPlanets.setValue(curr.filter(p => p.name !== planet.name));
  }

  removeZodiac(zodiac: AstroItem): void {
    const curr = this.selectedZodiacs.value || [];
    this.selectedZodiacs.setValue(curr.filter(z => z.name !== zodiac.name));
  }

  private buildTags(): string[] {
    const mode = this.selectedAction.value ?? 'invocation';
    const planets = this.selectedPlanets.value ?? [];
    const zodiacs = this.selectedZodiacs.value ?? [];

    const tags: string[] = ['Ritual_Opening'];

    if (mode === 'invocation') {
      for (const p of planets) {
        tags.push(`${p.name}_Gate_Invocation_Ritual`, `${p.name}_Invocation_Ritual`);
      }
      for (const z of zodiacs) {
        tags.push(`${z.name}_Gate_Invocation_Ritual`, `${z.name}_Invocation_Ritual`);
      }
    } else {
      for (const p of planets) {
        tags.push(`${p.name}_Gate_Banishing_Ritual`);
      }
    }

    tags.push('Ritual_Closing');
    return Array.from(new Set(tags));
  }

  // ---- Submit ----
  public onSubmit() {
    this.isLoading = true;

    const mode = this.selectedAction.value;
    const hasPlanet = (this.selectedPlanets.value ?? []).length > 0;
    const hasZodiac = (this.selectedZodiacs.value ?? []).length > 0;

    if (mode === 'banishing' && !hasPlanet) {
      this.snack.open('Please select at least one Planet for Banishing.', 'OK', { duration: 3000 });
      this.isLoading = false;
      return;
    }
    
    if (mode === 'invocation' && !hasPlanet && !hasZodiac) {
      this.snack.open('Please select at least one Planet or Zodiac Sign for Invocation.', 'OK', { duration: 3000 });
      this.isLoading = false;
      return;
    }

    const tags = this.buildTags();
    const endpoint = "ritual-invocation/add-ritual-configuration";
    const cookieDetails = this.cookieData; 
    
    const payload = {
      user_id: cookieDetails.cookie.cookie.userinfo._id,
      ritual_tags: tags
    }

    this.apiService.getHttpDataPost(endpoint, payload).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        this.closeModal();
        const config_id = response.results._id;
        this.router.navigate(
          ['/perennial-mandalism-dashboard/ritual-result', config_id],
        );
      },
      error: (error: any) => {
        this.isLoading = false;
        this.snack.open('Failed to create ritual. Please try again.', 'OK', { duration: 3000 });
        console.error('API Error:', error);
      },
    });
  }
}